import { InvoiceState } from "./invoice-state";

export default class InvoiceFilter {
  public text: string = "";
  public status: InvoiceState | null = null;
  public excludestatus: InvoiceState | null = InvoiceState.Settled;
}
